module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticStyle: {
      "margin-top": "60px",
      "background-color": "rgb(240, 238, 246)",
      "padding": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "offset": 8
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-caf36bf4"}!./src/layouts/login/login.html
// module id = 820
// module chunks = 1